(function () {
  'use strict';

  document.addEventListener('click', function (e) {
  var removeBtn = e.target.closest('m-cart-remove-button');
  if (!removeBtn) return;

  /* Check data-paired-key on the button itself (cart page) or parent wrap (drawer) */
  var pairedKey = removeBtn.dataset.pairedKey || '';

  if (!pairedKey) {
    var quantityWrap = removeBtn.closest('[data-paired-key]');
    if (quantityWrap) pairedKey = quantityWrap.dataset.pairedKey || '';
  }

  if (!pairedKey) return;

  e.preventDefault();
  e.stopImmediatePropagation();

    e.preventDefault();
    e.stopImmediatePropagation();

    /* Find all cart items that share this paired key */
    var updates = {};

    document.querySelectorAll('[data-cart-item]').forEach(function (cartItem) {
      cartItem.querySelectorAll('[data-cart-item-property]').forEach(function (prop) {
        var nameEl  = prop.querySelector('[data-cart-item-property-name]');
        var valueEl = prop.querySelector('[data-cart-item-property-value]');
        if (!nameEl || !valueEl) return;

        var propName  = nameEl.textContent.trim().replace(':', '').trim();
        var propValue = valueEl.textContent.trim();

        if (propName === '_paired_key' && propValue === pairedKey) {
          var variantId = cartItem.querySelector('[data-quantity-variant-id]');
          if (variantId && variantId.dataset.quantityVariantId) {
            updates[variantId.dataset.quantityVariantId] = 0;
          }
        }
      });
    });

    if (Object.keys(updates).length === 0) return;

    /* Remove both items via /cart/update.js */
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      refreshCartDrawer();
    })
    .catch(function (err) {
      console.error('[Cordset Cart] Remove error:', err);
    });

  }, true); /* capture phase — fires before Minimog's own handler */


  function refreshCartDrawer() {
    var cartDrawer = document.querySelector('m-cart-drawer');
    if (!cartDrawer) { window.location.reload(); return; }

    fetch(window.Shopify.routes.root + 'cart?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc    = parser.parseFromString(html, 'text/html');

        var sections = [
          '[data-minimog-cart-items]',
          '[data-minimog-cart-discounts]',
          '[data-cart-subtotal]',
          '[data-minimog-gift-wrapping]'
        ];

        sections.forEach(function (selector) {
          var target = cartDrawer.querySelector(selector);
          var source = doc.querySelector(selector);
          if (target && source) target.innerHTML = source.innerHTML;
        });

        /* Update cart count bubble */
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var count = cart.item_count;
            document.querySelectorAll('.m-cart-count-bubble').forEach(function (el) {
              if (count > 0) {
                el.textContent = count;
                el.classList.remove('m:hidden');
              } else {
                el.classList.add('m:hidden');
              }
            });

            /* Show empty state if cart is empty */
            if (count === 0) {
              cartDrawer.classList.add('m-cart--empty');
            }
          })
          .catch(function () {});

        /* Fire Minimog pubsub so other components stay in sync */
        if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartDrawerUpdate);
        }
      })
      .catch(function () { window.location.reload(); });
  }

  /* ── Stranded paired item safety check ─────────────────
     On page load, find any hidden-product cart items that
     have a _paired_key with NO matching top product.
     If found, remove them automatically.
  ─────────────────────────────────────────────────────── */
  function removeStrandedPairedItems() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Build a set of all paired_keys that belong to a TOP (non-hidden) item */
        var topKeys = {};
        cart.items.forEach(function (item) {
          var props = item.properties || {};
          var role  = props['_cordset_pair'] || '';
          var key   = props['_paired_key']   || '';
          if (role === 'top' && key) {
            topKeys[key] = true;
          }
        });

        /* Find bottom items whose key has no matching top */
        var strandedUpdates = {};
        cart.items.forEach(function (item) {
          var props = item.properties || {};
          var role  = props['_cordset_pair'] || '';
          var key   = props['_paired_key']   || '';
          if (role === 'bottom' && key && !topKeys[key]) {
            strandedUpdates[item.variant_id] = 0;
          }
        });

        if (Object.keys(strandedUpdates).length === 0) return;

        /* Remove stranded items silently */
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: strandedUpdates })
        })
        .then(function () { window.location.reload(); })
        .catch(function (err) { console.error('[Cordset] Stranded remove error:', err); });
      })
      .catch(function () {});
  }

  /* Run on every page load */
  removeStrandedPairedItems();

})();